import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  getComparisonDateRange,
} from '@bingads-webui-campaign/overview-cards-common';
import { StringsMapping, metrici18nKeys } from '../../common/strings';

function KpiGrid(props) {
  const {
    currentDate,
    compareDate,
    item,
    newI18n,
    metric,
  } = props;

  const changeString = useMemo(() => newI18n.getString(StringsMapping.Hover_Change, {
    value: item.formattedValue,
    percentageValue: item.formattedPercentageValue,
  }), [item.formattedPercentageValue, item.formattedValue, newI18n]);

  const metricCurrent = useMemo(
    () => newI18n.getString(metrici18nKeys[metric], { value: item.formattedMetrics }),
    [item.formattedMetrics, metric, newI18n]
  );

  const metricCompared = useMemo(
    () => newI18n.getString(metrici18nKeys[metric], { value: item.formattedPeriodMetrics }),
    [item.formattedPeriodMetrics, metric, newI18n]
  );

  return (
    <div className="kpi-grid">
      <div className="kpi-current">
        <div className="kpi-date-range">
          {currentDate}
        </div>
        <span>{metricCurrent}</span>
      </div>
      <div className="kpi-comparison">
        <div className="kpi-date-range">
          {compareDate}
        </div>
        <span>{metricCompared}</span>
      </div>
      <div className="kpi-change">
        <div className="bar-icon" />
        <span>{changeString}</span>
      </div>

    </div>
  );
}

function GridHoverContainer(props) {
  const {
    isGrid,
    isIncrease,
    item,
    rowClass,
    newI18n,
    dateRange,
    metric,
  } = props;

  const startDate = useMemo(
    () =>
      newI18n.formatDate(dateRange.start),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dateRange.start]
  );

  const endDate = useMemo(
    () =>
      newI18n.formatDate(dateRange.end),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dateRange.end]
  );

  const compareDate = useMemo(
    () => {
      const comparisonDateRange = getComparisonDateRange(dateRange);
      const comparisonStartDate = newI18n.formatDate(comparisonDateRange.start);
      const comparisonEndDate = newI18n.formatDate(comparisonDateRange.end);
      if (startDate === endDate) {
        return comparisonStartDate;
      }
      return `${comparisonStartDate} - ${comparisonEndDate}`;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dateRange]
  );

  const currentDate = useMemo(
    () => {
      if (startDate === endDate) {
        return startDate;
      }
      return `${startDate} - ${endDate}`;
    },
    [startDate, endDate]
  );

  const hoverClassName = useMemo(
    () => {
      if (isGrid) {
        return 'graph-hover-target';
      }
      return 'pop-hover-target';
    },
    [isGrid]
  );

  const KpiColorClassName = useMemo(
    () => (isIncrease ? 'kpi-increased' : 'kpi-declined'),
    [isIncrease]
  );

  return (
    <div className={`${hoverClassName} ${KpiColorClassName} ${rowClass}`}>
      <div className="hover-container">
        <div className="hover-content">
          <div className="entity-name">{item.name}</div>
          <KpiGrid
            isIncrease={isIncrease}
            currentDate={currentDate}
            compareDate={compareDate}
            item={item}
            newI18n={newI18n}
            metric={metric}
          />
        </div>
      </div>
    </div>
  );
}

GridHoverContainer.defaultProps = {
  isGrid: false,
  isIncrease: false,
};

GridHoverContainer.propTypes = {
  isGrid: PropTypes.bool,
  isIncrease: PropTypes.bool,
  rowClass: PropTypes.string.isRequired,
  item: PropTypes.shape({
    increaseSpace: PropTypes.number,
    increaseBar: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  dateRange: PropTypes.shape({
    start: PropTypes.shape({}).isRequired,
    end: PropTypes.shape({}).isRequired,
  }).isRequired,
  metric: PropTypes.string.isRequired,
};

KpiGrid.defaultProps = {
};

KpiGrid.propTypes = {
  currentDate: PropTypes.string.isRequired,
  compareDate: PropTypes.string.isRequired,
  item: PropTypes.shape({
    formattedValue: PropTypes.string,
    formattedPercentageValue: PropTypes.string,
    formattedMetrics: PropTypes.string,
    formattedPeriodMetrics: PropTypes.string,
  }).isRequired,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  metric: PropTypes.string.isRequired,
};

export default GridHoverContainer;
